import * as React from 'react';
import {createSvgIcon} from "@material-ui/core/utils";

export default createSvgIcon(
    <path d="M19,19H5V5h14V19z M3,3v18h18V3H3z M17,15.59L15.59,17L12,13.41L8.41,17L7,15.59L10.59,12L7,8.41L8.41,7L12,10.59L15.59,7 L17,8.41L13.41,12L17,15.59z" />, 'disableBox');